
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"22","viewBox":"0 0 33 27"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-54C1570D-A686-D9E8-CCB7-2397AAF6EA2A)"}},[_c('path',{attrs:{"fill":"#ffa306","d":"M15.719 2.617c0-.724.252-1.34.754-1.851C16.976.256 17.595 0 18.328 0c.734 0 1.352.256 1.855.766l12.323 12.508-12.323 12.508c-.503.51-1.121.765-1.855.765-.733 0-1.352-.254-1.855-.765-.502-.51-.754-1.138-.754-1.883 0-.744.252-1.371.754-1.882l5.974-6.127H2.578c-.712 0-1.32-.255-1.824-.765A2.544 2.544 0 010 13.274c0-.723.252-1.35.754-1.883.504-.53 1.112-.797 1.824-.797h19.869l-5.974-6.127a2.541 2.541 0 01-.754-1.85"}})])])
          )
        }
      }
    